import { defineComponent as s } from "vue";
const i = s({
  name: "RAccordion",
  data() {
    return {
      openItems: []
    };
  },
  props: {
    initiallyOpenedItem: {
      type: Number,
      default: null
    }
  },
  watch: {
    initiallyOpenedItem(e) {
      this.openItems = [], this.openItems.push(e);
    }
  },
  mounted() {
    this.initiallyOpenedItem !== null && this.openItems.push(this.initiallyOpenedItem);
  },
  methods: {
    getItemIndex(e) {
      return this.openItems.indexOf(e);
    },
    openItem(e) {
      this.isItemOpen(e) || this.openItems.push(e);
    },
    closeItem(e) {
      if (this.isItemOpen(e)) {
        const t = this.getItemIndex(e);
        this.openItems.splice(t, 1);
      }
    },
    isItemOpen(e) {
      return this.getItemIndex(e) >= 0;
    },
    toggleItem(e) {
      this.isItemOpen(e) ? this.closeItem(e) : this.openItem(e);
    }
  },
  render() {
    return this.$slots.default ? this.$slots.default({
      openItem: this.openItem,
      closeItem: this.closeItem,
      isItemOpen: this.isItemOpen,
      toggleItem: this.toggleItem
    }) : null;
  }
});
export {
  i as _
};
